import { IGetCentroCustoEnderecoUseCase } from "../../../presentation/useCases/read/get_centro_custo_endereco_use_case";
import { CentroCusto } from "../../models/centro_custo";
import { CentroCustoEndereco } from "../../models/centro_custo_endereco";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetAllCentroCustoUseCase
 */

export class GetCentroCustoEnderecoUseCase implements IGetCentroCustoEnderecoUseCase {
    constructor(private readonly repository: IComercialRepository) { }

    async getCentroCustoEnderecoByid(idCentroCustoEndereco: number): Promise<CentroCustoEndereco> {
        const response = await this.repository.getCentroCustoEnderecoById(idCentroCustoEndereco);
        return response;

    };

}
